import { render, staticRenderFns } from "./CustomerModels.vue?vue&type=template&id=c1cf24fe&scoped=true"
import script from "./CustomerModels.vue?vue&type=script&lang=js"
export * from "./CustomerModels.vue?vue&type=script&lang=js"
import style0 from "./CustomerModels.vue?vue&type=style&index=0&id=c1cf24fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf24fe",
  null
  
)

export default component.exports